import "./App.css";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import { Outlet, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "./contexts/auth";
import { ErrorBoundary } from "react-error-boundary";
import FallbackComponent from "./components/fallbackRenders/FallbackComponent";

function App() {
  const { pathname } = useLocation();
  return (
    <>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <AuthProvider>
        <Navbar />
        <div className="flex h-[calc(100vh-60px)]">
          {pathname !== "/login" && (
            <div className="w-56 h-full">
              <Sidebar />
            </div>
          )}
          <div className="w-full h-full">
            <ErrorBoundary fallbackRender={FallbackComponent}>
              <Outlet />
            </ErrorBoundary>
          </div>
        </div>
      </AuthProvider>
    </>
  );
}

export default App;
